module.exports = __webpack_public_path__ + "img/c3.a65e6fa6.png";